import React, {Component} from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import template from './FabricatorsHeader.rt';
import {getFabricators, cloneFabricatorSetSearchTerm} from './FabricatorsActions';

export default class FabricatorsHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      term: ''
    };

    this.debouncedSearch = debounce(this.search, 250);
  }

  setSearchTerm = (term) => {
    this.setState({term}, () => {
      this.debouncedSearch(term);
    });
  }

  search(term) {
    if (!this.props.cloningFabFeaturesData) {
      this.props.dispatch(getFabricators(0, 50, term));
    } else {
      this.props.dispatch(cloneFabricatorSetSearchTerm(term))
    }
  }

  render = template;
};

FabricatorsHeader.propTypes = {
  dispatch: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  cloningFabFeaturesData: PropTypes.object
}
